import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import { AppModule } from '@blade/common/store/app';
let LangSelect = class LangSelect extends Vue {
    size;
    levelList = [];
    langList = [];
    updateDelay = 0;
    get language() {
        return AppModule.language;
    }
    created() { }
    mounted() {
        this.$root.$i18n.locale = this.language;
        this.langList = [
            { title: 'English', value: 'en-us' },
            { title: '中文', value: 'zh' },
        ];
    }
    handleSetLanguage(lang) {
        this.$root.$i18n.locale = lang;
        this.$i18n.locale = lang;
        AppModule.SET_LANGUAGE(lang);
        this.$elmessage({
            showClose: true,
            message: this.$t('switchLang').toString(),
            type: 'success',
            duration: 1000,
        });
        this.updateDelay = window.setTimeout(() => { }, 1000);
        // if (this.$route?.meta?.langReload) {
        window.location.reload();
        // }
    }
    beforeDestroyed() {
        window.clearTimeout(this.updateDelay);
    }
};
__decorate([
    Prop({ default: '14px' })
], LangSelect.prototype, "size", void 0);
LangSelect = __decorate([
    Component({
        i18n: {
            messages: {
                'en-us': {
                    lang: 'English',
                    switchLang: 'Language switch to English',
                },
                zh: {
                    lang: '中文',
                    switchLang: '当前语言中文',
                },
            },
        },
    })
], LangSelect);
export default LangSelect;
